import { render, staticRenderFns } from "./ClientEmailNotificationFormReviewRequest.vue?vue&type=template&id=54ba1a0b&"
import script from "./ClientEmailNotificationFormReviewRequest.vue?vue&type=script&lang=js&"
export * from "./ClientEmailNotificationFormReviewRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports